import { IUserOptionsStore } from '../stores/userOptionsStore';
import AccessRightLevel from '../typings/security/accessRightLevel';

export default class AccessManager {
	private readonly _userPermissionsStore: IUserOptionsStore;

	constructor(systemSettingsStore: IUserOptionsStore) {
		this._userPermissionsStore = systemSettingsStore;
		this.hasAccessTo = this.hasAccessTo.bind(this);
	}

	public hasAccessTo(functionName: string, minimumAccessLevel: AccessRightLevel): boolean {
		const permissions = this._userPermissionsStore.permissions;
		if (!permissions) {
			return false;
		}

		const level = permissions[functionName];
		if (level != undefined) {
			return level != AccessRightLevel.Deny && level >= minimumAccessLevel;
		}

		return false;
	}
}
